/* eslint-disable */
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Login from 'views/auth/login';
import DomainOrHosting from 'views/admin/invoice/DomainOrHosting';
import ProtectedAdminRoute from './ProtectedAdminRoute';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const EditProfile      = Loadable(lazy(() => import('views/dashboard/EditProfile')));
const InvoiceGenerate  = Loadable(lazy(() => import('views/admin/invoice/InvoiceGenerate')));
const InvoiceSetting   = Loadable(lazy(() => import('views/admin/invoice/InvoiceSetting')));
const PrintInvoice     = Loadable(lazy(() => import('views/admin/invoice/PrintInvoice')));
const HrExpenses       = Loadable(lazy(() => import('views/hr/HrExpenses')));
const AdminSalesperson = Loadable(lazy(() => import('views/admin/salesperson/AdminSalesperson')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      index: true,
      element: <Navigate to="/admin/login" replace />,
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: '/',
      element: (
        <ProtectedAdminRoute>
          <MainLayout />
        </ProtectedAdminRoute>
      ),
      children: [
        { path: 'dashboard',         element: <DashboardDefault /> },
        { path: 'editprofile',       element: <EditProfile /> },
        { path: 'invoice',           element: <InvoiceGenerate /> },
        { path: 'invoice-setting',   element: <InvoiceSetting /> },
        { path: 'domain-hosting',    element: <DomainOrHosting /> },
        { path: 'print-invoice/:id', element: <PrintInvoice /> },
        { path: 'hr-expenses',       element: <HrExpenses /> },
        { path: 'salesperson',       element: <AdminSalesperson /> },
      ],
    },
  ],
};

export default MainRoutes;